import { FC, useContext } from "react"

import { DatabaseFilled } from "@ant-design/icons"
import { Card, Col, Row, Space, Typography } from "antd"

import { Balance as CustomerBalance } from "@/components/Account/Balance"
import { FinanceReportTable } from "@/components/Finance/FinanceReportTable"
import { Balance } from "@/components/ManagerAccount/Balance"
import { CustomerContext } from "@/context/CustomerContext"


const { Title } = Typography

const FinanceReport: FC = () => {
  const userContext = useContext(CustomerContext)
  const isCustomer = userContext.isCustomer()

  return (
    <>
      <Card bordered={false} style={{ marginBottom: "1rem" }}>
        <Title level={3} style={{ marginBottom: "0em" }}>
          <Space size={12}>
            <div>
              <DatabaseFilled style={{ color: "rgba(74, 124, 255, 1)" }}/>
            </div>
            Финансовый отчёт за период
          </Space>
        </Title>
      </Card>

      <Row gutter={[0, 12]}>
        <Col span={24}>
          {!isCustomer ? 
            <Balance /> : 
            <CustomerBalance />
          }
        </Col>
        <Col span={24}>
          <FinanceReportTable />
        </Col>
      </Row>
    </>
  )
}

export default FinanceReport